<template>
    <icon :name="iconClass" :w="20" :h="20"></icon>
</template>

<script>
    export default {
        name: 'svgicon',
        props: {
            iconClass: {
                type: String,
                required: true
            },
            className: {
                type: String
            }
        },
        computed: {
            svgClass() {
                if (this.className) {
                    return 'svg-icon ' + this.className
                } else {
                    return 'svg-icon'
                }
            }
        }
    }
</script>

<style scoped>
    .svg-icon {
        width: 1em;
        height: 1em;
        vertical-align: -0.15em;
        fill: currentColor;
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/widgets/icons/SvgIcon.vue